module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm7.718 16.692l-6.7 7.014a.94.94 0 0 1-1.368 0l-1.368-1.434a1.046 1.046 0 0 1 0-1.432L16.968 18H9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h8.022l-2.682-2.836a1.046 1.046 0 0 1 0-1.432l1.368-1.434a.933.933 0 0 1 1.368 0l6.644 6.958a1.057 1.057 0 0 1-.002 1.436z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/right-circle-4.js
// module id = 1388
// module chunks = 14